<script>
  import {
    Tabs,
    TabsItem,
    Breadcrumb,
    BreadcrumbItem,
    Icon,
    Loader,
    Page,
  } from "@gl/design-system";
  import { RolesRepository } from "../../repositories/index";
  import { Route, Router } from "svelte-routing";
  import { navigate } from "../../utils/index";
  import { Layout } from "../../components/index";
  import { onMount, getContext } from "svelte";
  import { _, contract } from "../../stores/index";
  import RoleMembers from "./RoleMembers.svelte";
  import RolePolicies from "./RolePolicies.svelte";
  import CompareRole from "./CompareRole.svelte";
  const { isAuthorized } = getContext("isAuthorized");

  export let id;

  const basepath = "roles";

  let role = {};
  let loading = true;

  let selectedTab = "members";

  const setSelectedTabFromPathname = () => {
    const path = decodeURIComponent(window.location.pathname);
    if (path.includes("policies")) {
      selectedTab = "policies";
    } else if (path.includes("compare")) {
      selectedTab = "compare";
    } else {
      selectedTab = "members";
    }
  };

  async function fetchRole() {
    try {
      loading = true;

      role = await RolesRepository.getRole(id, { missingPolicies: true });
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchRole();
    setSelectedTabFromPathname();
  });
</script>

{#if !loading}
  <Layout selected="roles" fillHeight>
    <Page>
      <Breadcrumb slot="breadcrumb">
        <BreadcrumbItem
          on:click={() => navigate("/roles")}
          on:keypress={(e) => {
            if (e.key === "Enter") navigate("/roles");
          }}>{$_("common.roles")}</BreadcrumbItem
        >
        <BreadcrumbItem current>
          {$_("common.role")}: {role.data.name}
        </BreadcrumbItem>
      </Breadcrumb>

      <h3 slot="header" class="gl-title level-3">
        {$_("common.role")}: {role.data.name}
      </h3>

      <Tabs slot="tabs">
        {#if $isAuthorized("user_read")}
          <TabsItem
            selected={selectedTab === "members"}
            on:click={() => {
              selectedTab = "members";
              navigate(`/${basepath}/${id}/members`);
            }}
          >
            {$_("layout.role.members")}
          </TabsItem>
        {/if}

        {#if $isAuthorized("policy_read")}
          <TabsItem
            selected={selectedTab === "policies"}
            on:click={() => {
              selectedTab = "policies";
              navigate(`/${basepath}/${id}/policies`);
            }}
          >
            {$_("layout.role.policies")}
          </TabsItem>

          <TabsItem
            selected={selectedTab === "compare"}
            on:click={() => {
              selectedTab = "compare";
              navigate(`/${basepath}/${id}/compare`);
            }}
          >
            {$_("policies.compare")}
          </TabsItem>
        {/if}
      </Tabs>

      <div class="tab-content">
        <Router {basepath}>
          <Route path="/members">
            <RoleMembers {id} {role} />
          </Route>
          <Route path="/policies">
            <RolePolicies {id} {role} />
          </Route>
          <Route path="/compare">
            <CompareRole {role} />
          </Route>
        </Router>
      </div>
    </Page>
  </Layout>
{:else}
  <Loader />
{/if}
